export const SPRITES = {
  "weddingVenue": {
    srcs: "assets/locations/weddingVenue.png",
    width: 1216,
    height: 960
  },
  "bridalSuite": {
    srcs: "assets/locations/bridalSuite.png",
    width: 1216,
    height: 960
  },
  "gardenTerrace": {
    srcs: "assets/locations/gardenTerrace.png",
    width: 1216,
    height: 960
  },
  "rehearsalDinner": {
    srcs: "assets/locations/rehearsalDinner.png",
    width: 1216,
    height: 960
  },
  "newApartment": {
    srcs: "assets/locations/newApartment.png",
    width: 1216,
    height: 960
  },
  "familyGarden": {
    srcs: "assets/locations/familyGarden.png",
    width: 1216,
    height: 960
  },
  "isabellesOffice": {
    srcs: "assets/locations/isabellesOffice.png",
    width: 1216,
    height: 960
  },
  "isabelle": {
    srcs: "assets/characters/isabelle-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "daniel": {
    srcs: "assets/characters/daniel-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "emily": {
    srcs: "assets/characters/emily-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "emilysMother": {
    srcs: "assets/characters/emilysMother-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "minister": {
    srcs: "assets/characters/minister-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "assistant": {
    srcs: "assets/characters/assistant-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "client": {
    srcs: "assets/characters/client-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "homePageBackground": {
    srcs: "assets/pages/homePageBackground.png",
    width: 1216,
    height: 960
  },
  "lightOverlay": {
    srcs: "assets/overlays/lightOverlay.png",
    width: 1216,
    height: 960
  }
};

export const SOUNDS = {}
